import {
	showErrorNotification as exoShowErrorNotification,
	showSuccessNotification as exoShowSuccessNotification,
	type NotificationEntryProps,
} from "@exopengithub/exokit";
import i18n from "i18next";

// Portal wrapper: injects the Swedish default close-button label. These are
// plain functions (not components), so they use the i18next singleton rather
// than the useTranslation() hook — callable outside React render too.
// NotificationEntryProps (not the similarly-named NotificationProps, which is
// the presentational component's own props) is the imperative show*() shape —
// it has `message` and is what the ~180 real call sites already pass.
type NotificationEventProps = Omit<
	NotificationEntryProps,
	"icon" | "iconColor"
>;

export const showSuccessNotification = (props: NotificationEventProps) =>
	exoShowSuccessNotification({ closeAriaLabel: i18n.t("Close"), ...props });

export const showErrorNotification = (props: NotificationEventProps) =>
	exoShowErrorNotification({ closeAriaLabel: i18n.t("Close"), ...props });
